import React, { lazy } from 'react';
import { PrivateRoute } from '@/hooks/useAuth';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';

const InventoryMovementPage = lazy(() => import('@/containers/Views/InventoryMovements/InventoyMovementPage'));
const CreateInventoryMovementPage = lazy(
  () => import('@/containers/Views/InventoryMovements/CreateInventoryMovementPage'),
);

const InventoryRouter = (
  <Route path="inventory_movements">
    <Route 
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.InventoryMovements} 
          permissions={EBasicActions.Find}
        >
          <InventoryMovementPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="create"
      element={(
        <PrivateRoute 
          pageName={EPage.Roles} 
          permissions={EBasicActions.Create}
        >
          <CreateInventoryMovementPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default InventoryRouter;
